'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoSteps = function GoSteps(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm12.8 2.5c-2.9 0-5.3 3.9-5.3 8.8 0 2.6 0.7 5.5 1.3 9.9 0.5 3.4 1.8 6.3 4 6.3s3.7-1.9 3.7-5.4c0-1.2-1-3.1-1-4.7-0.1-2.9 1.9-4 1.9-6.7 0-4.9-1.7-8.2-4.6-8.2z m14.3 10c-2.9 0-4.6 3.3-4.6 8.2 0 2.7 2.1 3.8 2 6.7-0.1 1.6-1 3.5-1 4.7 0 3.5 1.4 5.4 3.6 5.4s3.5-2.9 4-6.3c0.7-4.4 1.4-7.3 1.4-9.9 0-4.9-2.4-8.8-5.4-8.8z' })
        )
    );
};

exports.default = GoSteps;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/steps.js
// module id = 2263
// module chunks = 168707334958949